bq.paymentMethods = function (element, options) {
    this.options = options;
    this.$element = $(element);

};

bq.paymentMethods.DEFAULTS = {};

bq.paymentMethods.prototype = {
    init: function () {
        this._initPaymentMethods();
        this.$element.on('bq.paymentMethods.init', {context: this}, this._initPaymentMethods);
        this._initPaymentMethodChanged();
    },

    _initPaymentMethods: function() {
        //Radio switching in supplier payment methods
        $('body').on('change', 'input.supplier-payment-method', function(e) {
            var showContainer = $(this).data('showContainer');
            var supplierId = $(this).data('supplierId');
            $('[data-payment-method-container]').each(function(i, c) {
                var $container = $(c);
                var supplierPrefix = 'supplier-' + supplierId + '-';
                var containerId = $container.data('paymentMethodContainer');

                if (containerId.indexOf(supplierPrefix) !== 0) { return; }

                if (containerId === showContainer) {
                    $container.show();
                    $container.trigger('bq.paymentMethods.paymentContainerSelected');
                } else {
                    $container.hide();
                }
            });

            var $form = $('[data-bulk-container="bulk_edit_payment_method"] form');
            if ($form.length) {
                // checkout
                $form.trigger('bq.onepage.payment.applyBtn.updateStatus');
            } else {
                // edit request
                $('.payment-method-wrapper').trigger('bq.editRequest.payment.applyBtn.updateStatus')
            }
        });

        $( window ).load(function() {
           $('.onepage-bulk-radio.supplier-payment-method[data-is-checked=1]').trigger("click");
        });
    },

    _initPaymentMethodChanged: function() {
        $('body').on('bq.paymentMethods.paymentContainerSelected', '[data-payment-method-container]', function() {
            if ($(this).data('isCreditCardContainer')) {
                var firstCreditCard = $(this).parent().find('[data-bq="payment-creditcards"]:checked');
                firstCreditCard.trigger('bq.paymentCreditcards.selected');
            }
        });
    },
};

$.fn.paymentMethods = function (option) {
    return this.each(function () {
        var $this = $(this);
        var data = $this.data('bq.paymentMethods');
        if (!data) {
            var options = $.extend({}, bq.paymentMethods.DEFAULTS, $this.data(), typeof (option) === 'object' && option);
            $this.data('bq.paymentMethods', (data = new bq.paymentMethods(this, options)));
        }
        data.init();
    });
};

$.fn.paymentMethods.Constructor = bq.paymentMethods;

bq.paymentMethodsInit = function () {
    $('[data-bq="payment-methods"]').each(function () {
        var $el = $(this);
        if ($el.data('bq.paymentMethods')) {
            return;
        }
        $el.paymentMethods($el.data());
    });
};

bq.init.push(bq.paymentMethodsInit);
